// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbody {\n  min-width:100% !important;\n  overflow: auto !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
